import cookies from '@/utils/cookies';
import { checkOnboardingWithMigration } from './utils';

const initialState = {
  orderOnboardingDone: true,
  foodCourtOnboardingDone: true,
  drinkingAgeApproved: false,
  payGoOnboardingDone: true,
};

// Cookie configuration
const COOKIE_CONFIG = {
  orderOnboardingDone: { hours: 24 * 365, path: '/' }, // 1 year
  foodCourtOnboardingDone: { hours: 24 * 365, path: '/' },
  payGoOnboardingDone: { hours: 24 * 365, path: '/' },
  drinkingAgeApproved: { hours: 24 * 30, path: '/' },
};

export default {
  state: initialState,
  mutations: {
    setOrderOnboardingDone(state, orderOnboardingDone) {
      state.orderOnboardingDone = orderOnboardingDone;
    },
    setFoodCourtOnboardingDone(state, foodCourtOnboardingDone) {
      state.foodCourtOnboardingDone = foodCourtOnboardingDone;
    },
    setDrinkingAgeApproved(state, drinkingAgeApproved) {
      state.drinkingAgeApproved = drinkingAgeApproved;
    },
    setPayGoOnboardingDone(state, payGoOnboardingDone) {
      state.payGoOnboardingDone = payGoOnboardingDone;
    },
  },
  actions: {
    async setOrderOnboardingDone({ commit }) {
      commit('setOrderOnboardingDone', true);
      cookies.setCookie({
        name: 'orderOnboardingDone',
        value: 'true',
        ...COOKIE_CONFIG.orderOnboardingDone,
      });
    },
    setFoodCourtOnboardingDone({ commit }) {
      commit('setFoodCourtOnboardingDone', true);
      cookies.setCookie({
        name: 'foodCourtOnboardingDone',
        value: 'true',
        ...COOKIE_CONFIG.foodCourtOnboardingDone,
      });
    },
    async setDrinkingAgeApproved({ commit }, drinkingAgeApproved) {
      commit('setDrinkingAgeApproved', drinkingAgeApproved);
      cookies.setCookie({
        name: 'drinkingAgeApproved',
        value: drinkingAgeApproved,
        ...COOKIE_CONFIG.drinkingAgeApproved,
      });
    },
    async setPayGoOnboardingDone({ commit }) {
      commit('setPayGoOnboardingDone', true);
      cookies.setCookie({
        name: 'payGoOnboardingDone',
        value: 'true',
        ...COOKIE_CONFIG.payGoOnboardingDone,
      });
    },
    checkOrderOnboardingDone({ commit, getters }) {
      const orderOnboardingEnabled = getters.functionalityOrderOnboardingEnabled;
      if (!orderOnboardingEnabled) {
        return;
      }

      const orderOnboardingDone = checkOnboardingWithMigration(
        'orderOnboardingDone',
        'orderOnboardingDone',
        COOKIE_CONFIG.orderOnboardingDone
      );
      
      commit('setOrderOnboardingDone', orderOnboardingDone);
    },
    checkDrinkingAgeApproved({ commit }) {
      const drinkingAgeApproved = cookies.getCookie('drinkingAgeApproved');
      commit('setDrinkingAgeApproved', !!drinkingAgeApproved);
    },
    checkFoodCourtOnboardingDone({ commit }) {
      const foodCourtOnboardingDone = checkOnboardingWithMigration(
        'foodCourtOnboardingDone',
        'foodCourtOnboardingDone',
        COOKIE_CONFIG.foodCourtOnboardingDone
      );
      
      commit('setFoodCourtOnboardingDone', foodCourtOnboardingDone);
    },
    checkPayGoOnboardingDone({ commit }) {
      const payGoOnboardingDone = checkOnboardingWithMigration(
        'payGoOnboardingDone',
        'payGoOnboardingDone',
        COOKIE_CONFIG.payGoOnboardingDone
      );
      
      commit('setPayGoOnboardingDone', payGoOnboardingDone);
    },
  },
  getters: {
    orderOnboardingDone: state => state.orderOnboardingDone,
    drinkingAgeApproved: state => state.drinkingAgeApproved,
    foodCourtOnboardingDone: state => state.foodCourtOnboardingDone,
    payGoOnboardingDone: state => state.payGoOnboardingDone,
  },
};
